var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"tab",class:{'is-active': _vm.isActive},attrs:{"to":{name: _vm.tab.name, params: _vm.tab.params}}},[_vm._v(" "+_vm._s(_vm.tab.text)+" "),(_vm.tab.count)?_c('div',{staticClass:"tab-count"},[_vm._v(_vm._s(_vm.tab.count))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }